import { render, staticRenderFns } from "./EditVendorForm.vue?vue&type=template&id=0a95c685&scoped=true&"
import script from "./EditVendorForm.vue?vue&type=script&lang=js&"
export * from "./EditVendorForm.vue?vue&type=script&lang=js&"
import style0 from "./EditVendorForm.vue?vue&type=style&index=0&id=0a95c685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95c685",
  null
  
)

export default component.exports